module.exports = __webpack_public_path__ + "static/media/Googlebusiness.69bb573c.png";